import { Link } from "react-router-dom";
import BrandLogo from "@/components/BrandLogo";

export default function PublicFooter() {
  return (
    <footer style={{ background: "var(--pine)", color: "#F5F2EC", marginTop: 80 }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-8 py-14 grid md:grid-cols-4 gap-8">
        <div>
          <BrandLogo className="h-14 mb-4" />
          <p className="serif-quote text-lg opacity-90 mb-3">"Come as a Guest. Leave as Family."</p>
          <p className="text-sm opacity-80 leading-relaxed">A peaceful 4-bedroom Himalayan retreat in Gadagushaini, Himachal Pradesh.</p>
        </div>
        <div>
          <div className="eyebrow mb-3" style={{ color: "#EAA14D" }}>Explore</div>
          <ul className="space-y-2 text-sm opacity-90">
            <li><Link to="/rooms">Suites</Link></li>
            <li><Link to="/amenities">Amenities</Link></li>
            <li><Link to="/attractions">Nearby Attractions</Link></li>
            <li><Link to="/gallery">Gallery</Link></li>
          </ul>
        </div>
        <div>
          <div className="eyebrow mb-3" style={{ color: "#EAA14D" }}>Stay</div>
          <ul className="space-y-2 text-sm opacity-90">
            <li><Link to="/availability">Check Availability</Link></li>
            <li><Link to="/faq">FAQ</Link></li>
            <li><Link to="/contact">Contact Host</Link></li>
          </ul>
        </div>
        <div>
          <div className="eyebrow mb-3" style={{ color: "#EAA14D" }}>Guest Access</div>
          <p className="text-sm opacity-80 mb-3">Already staying with us? Scan the in-room QR or:</p>
          <Link to="/guest/check-in" data-testid="footer-guest-checkin" className="text-sm underline">Self Check-In →</Link>
          <div className="mt-4 text-xs opacity-60">
            <Link to="/login" data-testid="footer-staff-login">Staff Portal</Link>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10 py-5 text-center text-xs opacity-60">© Freebird Nest · Gadagushaini, Himachal Pradesh · All rights reserved.</div>
    </footer>
  );
}
